export default __webpack_public_path__ + "static/media/box-active.3cbdd4bb.svg";